import { api } from "./api.ts";

import type { TagType } from "types/DataTypes";

export const rreTagAPI = api.injectEndpoints({
  endpoints: (build) => ({
    getRRETags: build.query<TagType[], { rreId: string }>({
      query: ({ rreId }) => ({
        url: `api/v1/rres/${rreId}/tags/`,
        method: "GET",
      }),
      providesTags: ["RRETags"],
    }),
    getRRETagById: build.query<TagType, { rreId: string; tagId: string }>({
      query: ({ rreId, tagId }) => ({
        url: `api/v1/rres/${rreId}/tags/${tagId}`,
        method: "GET",
      }),
      providesTags: ["RRETagById"],
    }),
    deleteRRETag: build.mutation<unknown, { rreId: string; tagId: string }>({
      query: ({ rreId, tagId }) => ({
        url: `api/v1/rres/${rreId}/tags/${tagId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["RRETags"],
    }),
    createRRETag: build.mutation<
      TagType,
      { rreId: string; data: { name: string } }
    >({
      query: ({ rreId, data }) => ({
        url: `api/v1/rres/${rreId}/tags/`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["RRETags"],
    }),
    patchRRETag: build.mutation<
      TagType,
      {
        rreId: string;
        data: { name: string };
        tagId: string;
      }
    >({
      query: ({ rreId, data, tagId }) => ({
        url: `api/v1/rres/${rreId}/tags/${tagId}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["RRETags", "RRETagById"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetRRETagsQuery,
  useGetRRETagByIdQuery,
  useCreateRRETagMutation,
  useDeleteRRETagMutation,
  usePatchRRETagMutation,
  useLazyGetRRETagByIdQuery,
} = rreTagAPI;
